import { gql } from "@apollo/client";

export const CANCEL_INVITATION = gql`
  mutation CancelInvitation($invitationMrn: ID!) {
    cancelInvitation(invitationMrn: $invitationMrn)
  }
`;
